import { FC } from "react";

import { RASTER_LANDINGS } from "@ryde/assets-landings";
import {
  getDownloadPassengerAppGoogleStorePath,
  getDownloadPassengerAppIosStorePath,
} from "@ryde/shared";

export const DownloadsAppButtons: FC = () => {
  return (
    <div className="downloads-app-container">
      <a
        href={getDownloadPassengerAppIosStorePath()}
        target="_blank"
        rel="noreferrer"
      >
        <img
          src={RASTER_LANDINGS.AppStorePNG}
          alt="Download on the App Store"
        />
      </a>
      <a
        href={getDownloadPassengerAppGoogleStorePath()}
        target="_blank"
        rel="noreferrer"
      >
        <img src={RASTER_LANDINGS.GooglePlayPNG} alt="Get it on Google Play" />
      </a>
    </div>
  );
};
